// extracted by mini-css-extract-plugin
export var cardCta = "what-fits-you-module--card-cta--od9Yc";
export var figureAbout = "what-fits-you-module--figure-about--LHmfE";
export var figureCard = "what-fits-you-module--figure-card--kWko7";
export var figureCardBody = "what-fits-you-module--figure-card-body--6Vr2F";
export var figureCardHeader = "what-fits-you-module--figure-card-header--pEyUS";
export var figureContent = "what-fits-you-module--figure-content--VT1fo";
export var figureGrid = "what-fits-you-module--figure-grid--TMBOn";
export var figureHero = "what-fits-you-module--figure-hero--oAS2l";
export var figureIcon = "what-fits-you-module--figure-icon--ZA7fy";
export var figureImage = "what-fits-you-module--figure-image--jN1bZ";
export var figureStyleList = "what-fits-you-module--figure-style-list--1E2Jq";
export var figureStyles = "what-fits-you-module--figure-styles--54W5e";
export var figureVisual = "what-fits-you-module--figure-visual--FF7LL";
export var finalCta = "what-fits-you-module--final-cta--3a98N";
export var finalCtaButton = "what-fits-you-module--final-cta-button--BRaNN";
export var finalCtaContent = "what-fits-you-module--final-cta-content--bUR8R";
export var fitsPage = "what-fits-you-module--fits-page--6RGBu";
export var heroCopy = "what-fits-you-module--hero-copy--uaGlt";
export var heroLead = "what-fits-you-module--hero-lead--pMyWd";
export var heroMeta = "what-fits-you-module--hero-meta--r7CoY";
export var heroVisual = "what-fits-you-module--hero-visual--p5X05";
export var inspirationCard = "what-fits-you-module--inspiration-card--P49Lz";
export var inspirationGrid = "what-fits-you-module--inspiration-grid--Jhdbn";
export var inspirationImage = "what-fits-you-module--inspiration-image--h4Rx9";
export var measureChecklist = "what-fits-you-module--measure-checklist--GKhc3";
export var measureContent = "what-fits-you-module--measure-content--9uwEF";
export var measureGuideLink = "what-fits-you-module--measure-guide-link--YyCi8";
export var measureSection = "what-fits-you-module--measure-section--y9ldA";
export var measureStep = "what-fits-you-module--measure-step--eoIyy";
export var measureSteps = "what-fits-you-module--measure-steps--t+XK-";
export var measureVisual = "what-fits-you-module--measure-visual--avMw9";
export var pageShell = "what-fits-you-module--page-shell--0w1U5";
export var primaryCta = "what-fits-you-module--primary-cta--3E2x0";
export var quizAnswer = "what-fits-you-module--quiz-answer--ToBS3";
export var quizAnswerSelected = "what-fits-you-module--quiz-answer-selected--eU5nG";
export var quizAnswers = "what-fits-you-module--quiz-answers--JnuA+";
export var quizBack = "what-fits-you-module--quiz-back--DaphL";
export var quizBadges = "what-fits-you-module--quiz-badges--loXL6";
export var quizCard = "what-fits-you-module--quiz-card--D2841";
export var quizConsistency = "what-fits-you-module--quiz-consistency--7-1qR";
export var quizIntro = "what-fits-you-module--quiz-intro--54mDr";
export var quizNav = "what-fits-you-module--quiz-nav--0F6wa";
export var quizPageShell = "what-fits-you-module--quiz-page-shell--1VaHm";
export var quizPrivacy = "what-fits-you-module--quiz-privacy--ZMlX2";
export var quizProgress = "what-fits-you-module--quiz-progress--J-Orv";
export var quizProgressFill = "what-fits-you-module--quiz-progress-fill--SAfJl";
export var quizProgressMeta = "what-fits-you-module--quiz-progress-meta--pMB5U";
export var quizQuestionHint = "what-fits-you-module--quiz-question-hint--Ok2Al";
export var quizQuestionNumber = "what-fits-you-module--quiz-question-number--ABJ37";
export var quizQuestionTitle = "what-fits-you-module--quiz-question-title--2QF7r";
export var quizRecommendations = "what-fits-you-module--quiz-recommendations--FBkQ1";
export var quizRestart = "what-fits-you-module--quiz-restart--K-aLF";
export var quizResult = "what-fits-you-module--quiz-result--siNQ9";
export var quizResultActions = "what-fits-you-module--quiz-result-actions--h6Gll";
export var quizResultCopy = "what-fits-you-module--quiz-result-copy--eEECv";
export var quizResultEyebrow = "what-fits-you-module--quiz-result-eyebrow--Oe+ry";
export var quizResultGrid = "what-fits-you-module--quiz-result-grid--zgmWW";
export var quizResultHeader = "what-fits-you-module--quiz-result-header--9Gr75";
export var quizResultImage = "what-fits-you-module--quiz-result-image--AsKAs";
export var quizResultTitle = "what-fits-you-module--quiz-result-title---UZZ1";
export var quizScoreBar = "what-fits-you-module--quiz-score-bar--8Xy5H";
export var quizScoreRow = "what-fits-you-module--quiz-score-row--UDa2E";
export var quizScores = "what-fits-you-module--quiz-scores--YW45Q";
export var quizSection = "what-fits-you-module--quiz-section--sMV0q";
export var sectionEyebrow = "what-fits-you-module--section-eyebrow--8HVox";
export var sectionHeader = "what-fits-you-module--section-header--lDRcZ";
export var stepNumber = "what-fits-you-module--step-number--3Ulxt";
export var styleTip = "what-fits-you-module--style-tip--A0bw8";
export var styleTipIcon = "what-fits-you-module--style-tip-icon--trNHb";
export var styleTipsGrid = "what-fits-you-module--style-tips-grid--955lg";